module.exports = __webpack_public_path__ + "img/9_117.a9179592.png";